import React, { useState } from "react";

import "../css/DealersandDistributors.css";

import dealerbg from '../img/dealer-dist.jpg';
import vasmall from '../img/1100va.jpeg';
import vamedium from '../img/2100va.jpeg';
import '../css/dealer.css';

const DistributorAppointment = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);

  const handleDropdownClick = (category) => {
    setSelectedCategory(category === selectedCategory ? null : category);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_Backend_URL}/dealers/dealersubmit`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        setResponseMessage("form has been successfully submitted!");
        form.reset(); 
      } else {
        setResponseMessage("There was an error submitting the form. Please try again.");
      }
    } catch (error) {
      setResponseMessage("An unexpected error occurred. Please try again.");
    }

    setShowMessage(true);

    setTimeout(() => {
      setShowMessage(false);
    }, 1000);
  };

  return (
    <div className="container-1">
      <div className="page-content">
        <div
          className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
          style={{
            backgroundImage: `url(${dealerbg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
          data-stellar-background-ratio="0.5"
        >
          <div className="overlay-main bg-black opacity-07" />
          <div className="container">
            <div className="sx-bnr-inr-entry">
              <div className="banner-title-outer">
                <div className="banner-title-name">
                  <h2 className="m-tb0">Dealer and Distributor</h2>
                  <p>Inverters with inbuilt lithium batteries</p>
                </div>
              </div>
              <div className="dux">
                <div className="additional-images">
                  <div className="image-item">
                    <img src={vasmall} alt="Image 1" />
                    <div className="image-text">1100 VA</div>
                  </div>
                  <div className="image-item">
                    <img src={vamedium} alt="Image 2" />
                    <div className="image-text">2100 VA</div>
                  </div>
                </div>
                <div className="content">
                  <ul style={{ color: "white" }}>
                    <li>Lifespan of more than 10 Years</li>
                    <li>Zero Maintainence</li>
                    <li>5 Year comprehensive warranty</li>
                    <li>Advanced BMS System</li>
                    <li>Integrated Dual LED Display</li>
                    <li>Wall Mounted / Portable application</li>
                  </ul>
                </div>
              </div>
              <div>
                <ul className="sx-breadcrumb breadcrumb-style-2">
                  <p style={{ color: "white", fontSize: 22, marginTop: 15 }}>
                    Contact us for business opportunity today
                  </p>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="section-full p-tb80 inner-page-padding">
          <div className="container">
            <div className="section-content">
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12">
                  <form id="contactForm" onSubmit={handleSubmit}>
                    <div>
                      <div className="section-head">
                        <div className="sx-separator-outer separator-left">
                          <div
                            className="sx-separator bg-white bg-moving bg-repeat-x"
                            style={{
                              backgroundImage:
                                "url(images/background/cross-line2.png)",
                            }}
                          >
                            <h3 className="sep-line-one">Form</h3>
                          </div>
                        </div>
                      </div>
                      {showMessage && (
                        <div id="responseMessage" className="success-message">
                          {responseMessage}
                        </div>
                      )}
                      <div className="form-group">
                        <input
                          name="name"
                          type="text"
                          required
                          className="form-control"
                          placeholder="Name"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          name="number"
                          type="text"
                          className="form-control"
                          required
                          placeholder="Mobile"
                        />
                      </div>
                      <div className="form-group">
                        <textarea
                          name="location"
                          rows={4}
                          className="form-control"
                          required
                          placeholder="Address"
                        />
                      </div>
                      <input
                        type="submit"
                        value="Submit"
                        className="site-button btn-half"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorAppointment;
